module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_innlandet_pos.bc4d973a.png";